import { FC } from "react";

import { TextWithIndicatorCell } from "../../grid";
import { IRenderColumnTemplate } from "./_core";

export const DateWithIndicatorCellTemplate: FC<IRenderColumnTemplate> = ({
  value,
  dateFormat,
}) => {
  return (
    <TextWithIndicatorCell dateFormat={dateFormat}>
      {value}
    </TextWithIndicatorCell>
  );
};
